// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_VerificaprecancelamentopororcamentoservicoidResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /orcamentos_servicos/verificaPreCancelamentoPorOrcamentoServicoID
 *
 * Returns warning messages about what will be cancelled when an orcamento_servico is cancelled.
 *
 * Data shape: array of warning message strings
 *
 * @see Orcamentos_servicos::verificaPreCancelamentoPorOrcamentoServicoID()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_VerificaprecancelamentopororcamentoservicoidResponseDados = string[];

export type OrcamentosServicos_VerificaprecancelamentopororcamentoservicoidResponse = ApiResponse<OrcamentosServicos_VerificaprecancelamentopororcamentoservicoidResponseDados>;

registerResponseContract('OrcamentosServicos_VerificaprecancelamentopororcamentoservicoidResponse', {})
